let vars = {};

vars.$document = $(document);
vars.$window = $(window);
vars.$body = $(document.body);
vars.$html = $(document.documentElement);
vars.$siteContainer = $('.site-container');
vars.$page = $('.page');
vars.$main = $('.main');
vars.$article = $('.article');
vars.$reviews = $('.reviews');
vars.$footer = $('.footer');
vars.$headerText = $('.header__target--main');
vars.$headerHref = $('.header__partner--mts');

vars.isMobile = () => innerWidth <= 1024;
vars.isEdgeIE = () => $(document.documentElement).hasClass('is-browser-edge') || $(document.documentElement).hasClass('is-browser-ie');
vars.isSafari = () => $(document.documentElement).hasClass('is-browser-safari');

export default vars;
